import { IonIcon } from '@ionic/react';
import { memo } from 'react';

const Icon = memo(IonIcon);

export default Icon;
